import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import styled from "@emotion/styled";
import {css} from "@emotion/core";
import { OutboundLink } from "gatsby-plugin-google-analytics";

const WomenBizForLeadersSection4Background = styled.div`
  min-height: 728px;
  background-color: ${props => props.theme.colors.white};
  display: block;
  color: ${props => props.theme.colors.gray_dark};
  margin: 0;
`
const WomenBizForLeadersSection4Content = styled.div`
  padding-top: 148px;
  padding-bottom: 125px;
  text-align:center;
  margin: 0;
  display:block;
  @media(min-width:1600px){
    width:1160px;
  }
  @media(max-width:992px){
    padding-top: 30px;
    padding-bottom: 30px;
  }
`
const WomenBizForLeadersSection4Title = styled.div`
  font: 58px/62px Abril Fatface;
  text-align:center;
  margin-bottom: 60px;
  @media(max-width:1199px){
    font: 56px/60px Abril Fatface;
  }
  @media(max-width:767px){
    font: 2.5rem/3rem Abril Fatface;
  }
`
const WomenBizForLeadersSection4Col = styled(Col)`
  text-align:center;
`

const ButtonFill6 = styled(Button)`
  height: 60px;
  color: ${props => props.theme.buttons.primary_button_violet.normal.color} !important;
  background-color: ${props => props.theme.buttons.primary_button_violet.normal.background_color} !important;
  border-color: ${props => props.theme.buttons.primary_button_violet.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props => props.theme.buttons.primary_button_violet.hovered.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.hovered.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.buttons.primary_button_violet.hovered.shadow} !important;
    @media(min-width:1199px){
      margin-top:45px;
      margin-bottom:3px;
    }
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.primary_button_violet.pressed.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.pressed.border_color} !important;
    box-shadow: none !important;
    @media(min-width:1199px){
      margin-top:45px;
      margin-bottom:3px;
    }
  }
  @media(min-width:922px) {
    margin-top:48px;
  }
  @media(max-width:921px){
    width:100%;
    margin-top: 20px;
  }
`
const ButtonOutline1 = styled(Button)`
  height: 60px;
  color: ${props => props.theme.buttons.secondary_big_button_violet.normal.color} !important;
  background-color: transparent !important;
  border-color: ${props => props.theme.buttons.secondary_big_button_violet.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props => props.theme.buttons.secondary_big_button_violet.hovered.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.secondary_big_button_violet.hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.buttons.secondary_big_button_violet.normal.shadow} !important;
    @media(min-width:1199px){
      margin-top:45px;
      margin-bottom:3px;
    }
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.secondary_big_button_violet.pressed.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.secondary_big_button_violet.pressed.border_color} !important;
    box-shadow: none !important;
    @media(min-width:1199px){
      margin-top:45px;
      margin-bottom:3px;
    }
  }
  @media(min-width:922px){
    margin-top:48px;
    margin-left:25px;
  }
  @media(max-width:921px){
    width:100%;
    margin-top: 20px;
    margin-bottom:20px;
  }
  @media(max-width:767px){
    width:100%;
    margin-bottom:50px;
  }
`

export default function WomenBizForLeadersSection4() {
  return (
  <WomenBizForLeadersSection4Background>
    <Container>
      <WomenBizForLeadersSection4Content>
          <WomenBizForLeadersSection4Title>
            Our network of mentors, mentees and team members come from Indonesia’s leading organizations
          </WomenBizForLeadersSection4Title>
          <WomenBizForLeadersSection4Col>
            <img css={css`max-width: 100%;`} alt="WomenWorks - Company Logos"
            src="/page-womenbiz-for-leaders-section4-img1.png"/>
          </WomenBizForLeadersSection4Col>
          <WomenBizForLeadersSection4Col>
            <OutboundLink id="Womenbiz6-GetConnected-Button" target="_blank" rel="noreferrer" href={"mailto:yours@womenworks.io" +
              "?subject=WomenBiz%20enquiry" +
              "&body=Dear%20WomenWorks%20team,%20we're%20interested%20to%20learn%20more%20about%20how%20WomenBiz%20could%20help%20our%20company.%20Please%20find%20below%20our%20contact%20information%20where%20you%20can%20reach%20us%20to%20discuss%20further.%0D%0A%0D%0A" +
              "Name:%0D%0A" +
              "Company:%0D%0A" +
              "Mobile:%0D%0A" +
              "Email%0D%0A%0D%0A" +
              "Thank%20you!"}>
              <ButtonFill6>
                Get connected with us!
              </ButtonFill6>
            </OutboundLink>
            
            <OutboundLink id="Womenbiz6-DownloadOurPrograms-Button" target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/13vFQgFKOJD6y2OL5vCU0iZdf0a3yCv8L/view?usp=sharing">
              <ButtonOutline1 buttontype="secondary_big_button_violet">
                Download our programs
              </ButtonOutline1>
            </OutboundLink>

          </WomenBizForLeadersSection4Col>
          
      </WomenBizForLeadersSection4Content>
    </Container>
  </WomenBizForLeadersSection4Background>
  )
}
